module.exports = __webpack_public_path__ + "img/Cart Light.f2b02b72.svg";